<template>
<div ref="holder"
     class='parallax-wrapper'
     v-bind:class="classObject">
    <div ref="parallax"
         class="parallax"
         :class="{'not-wrapped' : !wrapped}"
         v-bind:style="{ transform: elTransform, top: elTop + 'px', height: elHeight + 'px' }">
        <slot></slot>
    </div>
</div>

</template>

<script>
import EventBus from '@/config/event-bus';
// import imagesLoaded from 'vue-images-loaded';
export default {
    name: 'parallax',
    directives: {
        // imagesLoaded
    },
    methods: {
        layout()  {
            this.initParallax()
        }
    },

    data: () => ({
        height: 0,
        bounds: {},
        topBound: 0
    }),

    mounted()  {
        this.initParallax()
    },

    props: [

        'speedFactor',

        'wrapped',

        'global'
    ],

    computed: {

        classObject: function()  {
            return {
                'wrapped': this.wrapped
            }
        },

        scrollTop()  {
            return this.$store.getters['app/getState']('scrollTop')
        },

        elTransform()  {

            let start = this.topBound - window.innerHeight

            let end = start + window.innerHeight + this.height
            end += this.wrapped ? 0 : this.move / 2

            var percentage = this.scrollProgress(start, end, this.scrollTop)
            let currentMove = this.move * percentage

            return 'translate3d(' + 0 + 'px,' + currentMove + 'px, ' + 0 + 'px)'
        },

        move()  {
            return this.global ? window.innerHeight * this.speedFactor : this.height * this.speedFactor
        },

        elHeight()  {
            if (!this.wrapped) {
                return
            }

            var newh = this.height + Math.abs(this.move)

            return newh
        },

        elTop()  {
            var m = -this.move

            return this.wrapped && m > 0 ? 0
                : this.wrapped ? m
                    : m / 2
        }
    },

    methods: {
        initParallax()  {
            var self = this

            EventBus.$on('scrolling', (top) => {
                this.scrollTop = top
            })

            // setTimeout(function(){
            requestAnimationFrame(() => {
                self.resizeHandler()
                self.setupListeners()
            })
        // }, 200);
        },

        // returning the scroll progress from 0 to 1 in between start/end pixels
        scrollProgress(start, end, scrollTop)  {
            var scrollTop = scrollTop || this.scrollTop,
                factor = (end - start) / 100,
                scrollStart = (scrollTop - start) / factor,
                percentage = (scrollTop >= start && scrollTop <= end) ? scrollStart / 100 : (scrollTop > start) ? 1 : 0

            return percentage
        },

        setupListeners()  {
            window.addEventListener('resize', this.resizeHandler, false)
        },

        resizeHandler()  {

            if (!this.$el) {
                return
            }

            this.height = this.$el.offsetHeight
            this.bounds = this.$el.getBoundingClientRect()
            this.topBound = this.bounds.top + this.scrollTop
        }

    }
}

</script>

<style lang='scss' scoped="">
.parallax-wrapper {
    height: 100%;
}


.parallax {
    position: relative;
    will-change: transform;
    /*transition: transform 0.3s cubic-bezier(0.15, 0.9, 0.34, 0.95);*/
}

.wrapped{
    overflow: hidden;
}

.not-wrapped {
    @media (max-width: 991px) {
        transform: none!important;
        top: 0!important;
    }
}


img {
    height: 100%;
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// parallax.vue?326a89fb